import { render } from "./PreMatchReport.vue?vue&type=template&id=0cfacf56&scoped=true"
import script from "./PreMatchReport.vue?vue&type=script&lang=js"
export * from "./PreMatchReport.vue?vue&type=script&lang=js"

import "./PreMatchReport.vue?vue&type=style&index=0&id=0cfacf56&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfacf56"]])

export default __exports__